import { useBootstrapApp } from "./hooks/useBootstrapApp";


const StandAloneApp = () => {
  const content = useBootstrapApp();
  return content;
};

export default StandAloneApp;